import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'fastr-ui-ai-chat-actions',
  templateUrl: './ai-chat-actions.component.html',
  styleUrls: ['./ai-chat-actions.component.scss'],
})
export class AiChatActionsComponent {
  @Input() reviewAndSearchLabel = 'Review & Search';
  @Input() refineLabel = 'Help me refine this';
  @Input() continueLabel = 'Continue';
  @Input() backLabel = 'Back';
  @Input() showSecondaryActions = true;
  @Input() showContinueAction = true;
  @Input() showBackAction = false;
  @Input() reviewAndSearchDisabled = false;
  @Input() refineDisabled = false;
  @Input() continueDisabled = false;

  @Output() reviewAndSearch = new EventEmitter<void>();
  @Output() refine = new EventEmitter<void>();
  @Output() continued = new EventEmitter<void>();
  @Output() backed = new EventEmitter<void>();

  submitReviewAndSearch(): void {
    if (this.reviewAndSearchDisabled) {
      return;
    }

    this.reviewAndSearch.emit();
  }

  submitRefine(): void {
    if (this.refineDisabled) {
      return;
    }

    this.refine.emit();
  }

  submitContinue(): void {
    if (this.continueDisabled) {
      return;
    }

    this.continued.emit();
  }

  submitBack(): void {
    this.backed.emit();
  }
}
